import { useEffect, useState } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';
import { getCustodyPages, saveCustodyPages } from '../../services/CustodyPagesService';

function apiError(err) {
    const raw = err?.response ? err.response.data : err?.message;
    if (typeof raw === 'string') return raw;
    return raw?.message || 'Não foi possível carregar as páginas.';
}

function CustodyPages() {
    const [pages, setPages] = useState([]);
    const [saving, setSaving] = useState(false);
    const [notification, setNotification] = useState({ type: '', text: '' });

    useEffect(() => {
        getCustodyPages()
            .then(result => setPages(result?.pages || []))
            .catch(err => setNotification({ type: 'error', text: apiError(err) }));
    }, []);

    function toggle(key) {
        setPages(current => current.map(page => (
            page.key === key ? { ...page, enabled: !page.enabled } : page
        )));
    }

    function onSave() {
        const access = {};
        pages.forEach(page => { access[page.key] = page.enabled !== false; });
        setSaving(true);
        saveCustodyPages(access)
            .then(result => {
                setPages(result?.pages || pages);
                setNotification({ type: 'success', text: 'Acesso da custódia atualizado.' });
            })
            .catch(err => setNotification({ type: 'error', text: apiError(err) }))
            .finally(() => setSaving(false));
    }

    const groups = [];
    pages.forEach(page => {
        let group = groups.find(item => item.name === page.group);
        if (!group) {
            group = { name: page.group, pages: [] };
            groups.push(group);
        }
        group.pages.push(page);
    });

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap align-items-center py-4">
                    <div>
                        <h1 className="h4 mb-1">Páginas da custódia</h1>
                        <p className="text-muted small mb-0">
                            Desmarque para esconder a página e o botão da sidebar dos usuários de custódia. Quem não é custódia continua vendo tudo.
                        </p>
                    </div>
                    <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving || !pages.length}>
                        {saving ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
                {groups.map(group => (
                    <div className="card border-0 shadow mb-4" key={group.name}>
                        <div className="card-body">
                            <h2 className="h6 mb-3">{group.name}</h2>
                            <div className="row">
                                {group.pages.map(page => (
                                    <div className="col-12 col-md-6 col-xl-4 mb-3" key={page.key}>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`page-${page.key}`}
                                                checked={page.enabled !== false}
                                                onChange={() => toggle(page.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`page-${page.key}`}>
                                                {page.label}
                                                <span className="text-muted small d-block">
                                                    {page.enabled !== false ? 'Acessível' : 'Oculta na sidebar'}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </main>
            <Footer />
            {notification.text ? (
                <Toast
                    type={notification.type}
                    text={notification.text}
                    onClose={() => setNotification({ type: '', text: '' })}
                />
            ) : null}
        </>
    );
}

export default CustodyPages;
